module.exports = __webpack_public_path__ + "static/media/img-temp-save.c8d1fbaa.jpg";